import React, { useRef } from "react";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { UiButton, UiTextArea } from "../../../../components";
import "./style.scss";

const RejectLawyerModal = ({
    isVisible,
    onClose,
    onSubmit,
    isLoading,
    reason,
    handleReasonChange
}) => {
    const reasonRef = useRef(null);
    
    const handleSubmit = () => {
        if (reason.trim()) {
            onSubmit(reason);
            handleClose();
        }
    };
    
    const handleClose = () => {
        onClose();
    };
    return (
        <Modal
            open={isVisible}
            onCancel={handleClose}
            footer={null}
            width={500}
            className="reject-lawyer-modal"
            centered
        >
            <div className="reject-modal-content">
                <div className="reject-modal-header">
                    <ExclamationCircleOutlined className="warning-icon" />
                    <h3 className="modal-title">Give Reason For reject this Advocate</h3>
                </div>
                <div className="reason-section">
                    <label className="reason-label">Reason</label>
                    <UiTextArea
                        ref={reasonRef}
                        value={reason}
                        onChange={handleReasonChange}
                        autoSize={{ minRows: 4, maxRows: 6 }}
                        className="reason-textarea"
                    />
                </div>
                <div className="modal-footer">
                    <UiButton 
                        className="cancel-btn"
                        onClick={handleClose}
                        disabled={isLoading}
                    >
                        No
                    </UiButton>
                    <UiButton 
                        type="primary"
                        className="submit-btn"
                        onClick={handleSubmit}
                        disabled={isLoading || !reason.trim()}
                        loading={isLoading}
                    >
                        Submit
                    </UiButton>
                </div>
            </div>
        </Modal>
    );
};

export default RejectLawyerModal;